<template>
  <div>
    <el-form
      size="mini"
      ref="form"
      :model="formData"
      :rules="rules"
      label-position="right"
      label-width="120px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="登记时间" prop="logTime" size="small">
            <el-date-picker
              style="width:100%"
              v-model="formData.logTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择异常登记时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="异常类型" prop="transAbnormalType">
            <dict-select
              clearable
              style="width:100%"
              v-model="formData.transAbnormalType"
              placeholder="请选择异常类型"
              default
              filterable
              size="small"
              :body="selectTransAbnormalType"
              :selectedLabel.sync="formData.transAbnormalTypeName"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="异常事件" prop="transAbnormalEventType">
            <dict-select
              clearable
              style="width:100%"
              v-model="formData.transAbnormalEventType"
              placeholder="请选择异常事件类型"
              default
              filterable
              size="small"
              :body="selectTransAbnormalEventType"
              :selectedLabel.sync="formData.transAbnormalEventTypeName"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="上报客户" prop="isSendCustomer" size="small">
            <el-select
              v-model="formData.isSendCustomer"
              size="small"
              style="width:100%"
            >
              <el-option label="否" value="N"> </el-option>
              <el-option label="是" value="Y"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="货物迟到数量"
            prop="transAbnormalQty"
            size="small"
          >
            <!-- <el-input
              style="width:100%"
              v-model="formData.transAbnormalQty"
              type="text"
              size="small"
            >
            </el-input> -->
            <el-input-number
              clearable
              v-model="formData.transAbnormalQty"
              controls-position="right"
              :min="0"
              :step-strictly="true"
              :step="1"
              style="width:100%"
              size="mini"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="客户投诉" prop="isComplaint" size="small">
            <el-select
              v-model="formData.isComplaint"
              size="small"
              style="width:100%"
            >
              <el-option label="否" value="N"> </el-option>
              <el-option label="是" value="Y"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="登记内容" prop="abnormalDesc">
            <el-input
              v-model="formData.abnormalDesc"
              clearable
              type="textarea"
              rows="7"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-row :span="24" class="ml-2">
          <el-form-item label="添加图片" required>
            <el-upload
              ref="upload"
              action="/store/oss/upload"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="handlePictureCardPreview"
              :http-request="uploadFile"
              :on-change="uploadOnChange"
              accept="image/png,image/jpeg"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog
              v-el-dialog-drag
              append-to-body
              :visible.sync="dialogVisible"
            >
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-row>
      </el-row>
    </el-form>
    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="confirm()" size="small">确认</el-button>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    registerData: {
      type: Object,
      default: () => {},
    },
    paramsData: {
      type: Array,
      default: () => [],
    },
    saveFlag: String,
  },
  data() {
    return {
      dialogVisible: false,
      wayBillAbnormalCode: '',
      selectTransAbnormalType: { type: 'transAbnormalType' },
      selectTransAbnormalEventType: { type: 'transAbnormalEventType' },
      // 图片预览
      dialogImageUrl: '',
      formData: {},
      imgList: [],
      fileList: [],
      rules: {
        logTime: [
          { required: true, message: '请选择登记时间', trigger: 'change' },
        ],
        transAbnormalType: [
          { required: true, message: '请选择异常类型', trigger: 'change' },
        ],
        transAbnormalEventType: [
          { required: true, message: '请选择异常事件', trigger: 'change' },
        ],
        isSendCustomer: [
          { required: true, message: '请选择是否上报客户', trigger: 'change' },
        ],
        isComplaint: [
          { required: true, message: '请选择客户是否投诉', trigger: 'change' },
        ],
        abnormalDesc: [
          { required: true, message: '请填写登记内容', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    // 图片预览查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadOnChange(file, fileList) {
      this.fileList = fileList
    },
    confirm() {
      if (this.saveFlag === 'A') {
        this.checkboxSave()
      } else {
        this.choiceOk()
      }
    },
    async choiceOk() {
      const data = Object.assign(this.registerData, this.formData)
      const result = await validate.formValidate([this.$refs.form])

      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      const uploadTask = this.fileList.map((file) => {
        return this.uploadFile(file)
      })

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      Promise.all(uploadTask)
        .then(() => {
          this.$api
            .carriageWaybillAbnormalSave({ ...data, imgList: this.imgList })
            .then((res) => {
              loadingInstance.close()
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'success',
              })
              this.close()
              this.$emit('reload')
            })
        })
        .catch(() => {
          loadingInstance.close()
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    async checkboxSave() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      const uploadTask = this.fileList.map((file) => {
        return this.uploadFile(file)
      })
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      Promise.all(uploadTask)
        .then(() => {
          this.$api
            .carriageWaybillAbnormalCheckBoxSaveApi({
              imgList: this.imgList,
              abnormalCodeList: this.paramsData,
              ...this.formData,
            })
            .then((res) => {
              loadingInstance.close()
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'success',
              })
              this.close()
              this.$emit('reload')
            })
        })
        .catch(() => {
          loadingInstance.close()
        })
        .finally(() => {
          loadingInstance.close()
        })
    },
    uploadFile(params) {
      return this.$api
        .SYS_UPLOAD(params.raw)
        .then((res) => {
          let img = {
            imageCode: res.body.id,
            imageUrl: res.body.url,
          }
          this.imgList.push(img)
        })
        .catch((e) => {
          console.log('异常图片上传失败 ==> ', e)
        })
    },
  },
}
</script>
